import React, { useState } from "react";
import { Info, X } from "lucide-react";
import "./ScoreCompetitionsModal.css";
import CompetitionLeaderboard from "./CompetitionLeaderboard";
import FollowPopup from "./FollowPopup";

function ScoreCompetitionsModal({
  visible,
  onClose,
  scoreLabels,
  scoreValues,
  messageLines,
  onInfo,
  competitionEntries = [],
  competitionOppositeMonthTop3 = [],
  competitionLoading = false,
  competitionError = "",
  competitionMonthLabel = "",
  competitionTexts = {},
  competitionTableLabels = {},
  onCompetitionRetry,
  profileDefault,
  competitionDisabled = false,
  competitionOverlayMessage = "",
  lang = "en",
  onFollow,
  isLoggedIn = false,
  currentUser = null,
}) {
  const [showFollowPopup, setShowFollowPopup] = useState(false);

  if (!visible) {
    return null;
  }

  return (
    <>
      <div className="score-modal-overlay" onClick={(e) => {
        if (e.target === e.currentTarget) {
          e.stopPropagation();
          onClose();
        }
      }} />
      <div
        className="score-modal"
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          className="score-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <X size={32} strokeWidth={2.5} />
        </button>

        <div className="score-modal-card">
          <button
            type="button"
            className="score-modal-info"
            onClick={onInfo}
            aria-label={scoreLabels?.info}
          >
            <Info size={20} strokeWidth={2.4} />
          </button>

          <div className="score-modal-total">
            <span className="score-modal-total-value">{scoreValues.score}</span>
            <span className="score-modal-total-label">{scoreLabels.score}</span>
          </div>

          <div className="score-modal-grid">
            <div className="score-modal-grid-item">
              <span className="score-modal-grid-value">{scoreValues.played}</span>
              <span className="score-modal-grid-label">{scoreLabels.played}</span>
            </div>
            <div className="score-modal-grid-item">
              <span className="score-modal-grid-value">{scoreValues.streak}</span>
              <span className="score-modal-grid-label">{scoreLabels.streak}</span>
            </div>
            <div className="score-modal-grid-item max-streak">
              <span className="score-modal-grid-value">{scoreValues.maxStreak}</span>
              <span className="score-modal-grid-label">{scoreLabels.maxStreak}</span>
            </div>
          </div>
        </div>
        <div className="score-modal-message">
          {messageLines.map((line, index) => (
            <span key={index}>{line}</span>
          ))}
        </div>
        <CompetitionLeaderboard
          entries={competitionEntries}
          oppositeMonthTop3={competitionOppositeMonthTop3}
          loading={competitionLoading}
          error={competitionError}
          monthLabel={competitionMonthLabel}
          texts={competitionTexts}
          tableLabels={competitionTableLabels}
          onRetry={onCompetitionRetry}
          profileDefault={profileDefault}
          variant="modal"
          active={visible}
          disabled={competitionDisabled}
          overlayMessage={competitionOverlayMessage}
          lang={lang}
          onFollow={onFollow}
          currentUser={currentUser}
          refreshLeaderboard={onCompetitionRetry}
        />
      </div>

      {onFollow && (
        <FollowPopup
          visible={showFollowPopup}
          onClose={() => setShowFollowPopup(false)}
          onFollow={async (usernameOrEmail) => {
            await onFollow(usernameOrEmail);
            setShowFollowPopup(false);
          }}
          lang={lang}
        />
      )}
    </>
  );
}

export default ScoreCompetitionsModal;
